import axios from "axios";
import { BASE_URL } from "./config";
import {
	clearAuthSession,
	getAuthToken,
	isValidCoreClsToken,
	parseJwtPayload,
} from "../../Auth/Services/tokenAuth";

const redirectToAuth = () => {
	if (typeof window === "undefined") return;
	if (window.location.pathname !== "/Auth") {
		window.location.href = "/Auth";
	}
};

const apiClient = axios.create({
	baseURL: BASE_URL,
	timeout: 15000,
	headers: {
		"Content-Type": "application/json",
	},
});

apiClient.interceptors.request.use((config) => {
	const token = getAuthToken();

	if (!isValidCoreClsToken(token)) {
		clearAuthSession();
		redirectToAuth();
		return Promise.reject(new axios.Cancel("Session expired or invalid"));
	}

	const payload = parseJwtPayload(token);
	config.headers.Authorization = `Bearer ${token}`;

	if (payload?.CLSToken) {
		config.headers.CLSToken = payload.CLSToken;
	}

	if (payload?.CLSUserUID) {
		config.headers.CLSUserUID = payload.CLSUserUID;
	}

	return config;
});

apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error?.response?.status === 401 || error?.response?.status === 403) {
			clearAuthSession();
			redirectToAuth();
		}

		return Promise.reject(error);
	},
);

export default apiClient;
